const Constants = {
    showExperimentalKey: "show-pre-release",
    filterAPIVersions: "filter-api-versions"
}

export default Constants;